import { Milliseconds } from '../../types/units';

interface CacheEntry<T> {
  data: T;
  timestamp: Milliseconds;
}

export class QueryCache {
  private cache: Map<string, CacheEntry<unknown>>;
  private defaultTTL: Milliseconds;

  constructor(defaultTTL: Milliseconds = 5 * 60 * 1000) {
    // 5 minutes default TTL (Time To Live)
    this.cache = new Map();
    this.defaultTTL = defaultTTL;
  }

  set<T>(key: string, data: T, ttl = this.defaultTTL): void {
    this.cache.set(key, {
      data,
      timestamp: Date.now() + ttl,
    });
  }

  get<T>(key: string): T | null {
    const entry = this.cache.get(key);
    if (!entry) return null;

    if (Date.now() > entry.timestamp) {
      this.cache.delete(key);
      return null;
    }

    return entry.data as T;
  }

  invalidate(key: string): void {
    this.cache.delete(key);
  }

  invalidateAll(): void {
    this.cache.clear();
  }

  invalidatePrefix(prefix: string): void {
    for (const key of Array.from(this.cache.keys())) {
      if (key.startsWith(prefix)) {
        this.cache.delete(key);
      }
    }
  }
}

export const queryCache = new QueryCache();
